import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpOptions } from '@app/shared/model/common.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    public formData: FormData = new FormData();
    public headers: HttpHeaders = new HttpHeaders();

    constructor(private readonly http: HttpClient) {}

    /**
     * Common GET method to connect with API services
     * @param url API Endpoint URL
     */
    get<T>(url: string, options?: HttpOptions): Observable<T> {
        options = options || {};
        options.headers = options.headers || this.headers;

        return this.http.get<T>(url, options);
    }

    /**
     * POST method
     * @param url API Endpoint URL
     * @param body Data to send
     */
    post<T>(url: string, body: unknown, options?: HttpOptions): Observable<T> {
        return this.http.post<T>(url, body, options);
    }

    /**
     * POST method for form data
     * @param url API Endpoint URL
     * @param body Data to send (FormData)
     */
    postFormData<T>(url: string, body: FormData): Observable<T> {
        const options = {
            headers: this.headers.delete('content-type'),
        };

        return this.http.post<T>(url, body, options);
    }

    /**
     * PUT method
     * @param url API Endpoint URL
     * @param body Data to update
     */
    put<T>(url: string, body?: unknown, options?: HttpOptions): Observable<T> {
        return this.http.put<T>(url, body, options);
    }

    /**
     * DELETE method
     * @param url API Endpoint URL
     * @param params Optional query params
     */
    delete<T>(url: string, options?: HttpOptions): Observable<T> {
        options = options || {};
        options.headers = options.headers || this.headers;

        return this.http.delete<T>(url, options);
    }

    /**
     * POST method for multipart form data
     * @param url API Endpoint URL
     * @param params Data to send
     */
    postWithMultiPartFormData<T>(
        url: string,
        body?: unknown,
        options?: HttpOptions
    ): Observable<T> {
        this.headers = this.headers.set('Content-Type', 'multipart/form-data');
        options = options || {};
        options.headers = options.headers || this.headers;

        return this.http.post<T>(url, body, options);
    }

    /**
     * PUT method for multipart form data
     * @param url API Endpoint URL
     * @param params Data to send
     */
    putWithMultiPartFormData<T>(
        url: string,
        body?: unknown,
        options?: HttpOptions
    ): Observable<T> {
        this.headers = this.headers.set('Content-Type', 'multipart/form-data');
        options = options || {};
        options.headers = options.headers || this.headers;

        return this.http.put<T>(url, body, options);
    }

    /**
     * Utility method to check if a property is null or undefined
     */
    public isPropertyNullOrUndefined(value: unknown): boolean {
        return value === null || value === undefined;
    }
}
